import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { IAppConfig } from './models/app-config.model';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AppConfig {

  static settings: IAppConfig;

  constructor(private httpClient: HttpClient) {
  }

  load() {
    const jsonFile = `assets/config/config.${environment.name}.json`;
    return new Promise<void>((resolve, reject) => {
      this.httpClient.get(jsonFile).toPromise().then((data) => {
        AppConfig.settings = <IAppConfig>data;
        resolve();
      }).catch((response: any) => {
        reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
      });
    });
  }
}
